<template>
  <section class="our-client-review-sec">
    <div class="sec-bg">
      <img src="@/assets/img/bg/ship-part-bg-01.png" alt="Bg" />
    </div>
    <div class="sec-round-colors">
      <span class="bg-orange round-small"></span>
    </div>
    <div class="container">
      <div class="section-header-two">
        <h2>What Our Clients Speak’s</h2>
        <p>Discover what our customers have think about us</p>
      </div>
      <div class="row">
        <div class="col-lg-4 col-md-6 d-flex">
          <div class="client-review-card flex-fill">
            <div class="client-review-content">
              <div class="client-img">
                <a href="javascript:void(0);" class="img-avatar"
                  ><img src="@/assets/img/profiles/avatar-16.jpg" alt="Img"
                /></a>
                <p>
                  The crew went above and beyond to ensure that every detail was
                  perfect, from the gourmet dining experience to the sunset
                  cruise along the coast. It was truly a dream come true, and we
                  can't wait to do it again!
                </p>
                <h5><a href="javascript:void(0);">Rabien Ustoc</a></h5>
                <span>Newyork, USA</span>
                <div class="quataion-mark">
                  <img
                    src="@/assets/img/icons/quatation-mark.svg"
                    class="img-fluid"
                    alt="Img"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 d-flex">
          <div class="client-review-card flex-fill">
            <div class="client-review-content">
              <div class="client-img">
                <a href="javascript:void(0);" class="img-avatar"
                  ><img src="@/assets/img/profiles/avatar-17.jpg" alt="Img"
                /></a>
                <p>
                  Our family vacation with Seaside Yacht Rentals was simply
                  spectacular! Renting a yacht was a new experience for us, and
                  it exceeded all our expectations. The kids had a blast
                  exploring the coastline.
                </p>
                <h5><a href="javascript:void(0);">Adrian Tres</a></h5>
                <span>Newyork, USA</span>
                <div class="quataion-mark">
                  <img
                    src="@/assets/img/icons/quatation-mark.svg"
                    class="img-fluid"
                    alt="Img"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 d-flex">
          <div class="client-review-card flex-fill">
            <div class="client-review-content">
              <div class="client-img">
                <a href="javascript:void(0);" class="img-avatar"
                  ><img src="@/assets/img/profiles/avatar-18.jpg" alt="Img"
                /></a>
                <p>
                  Our weekend yacht rental with Ocean Escape Charters was an
                  absolute blast! We wanted to plan a memorable getaway with our
                  friends, and chartering a yacht seemed like the perfect idea.
                </p>
                <h5><a href="javascript:void(0);">Mariana Fauzel</a></h5>
                <span>Newyork, USA</span>
                <div class="quataion-mark">
                  <img
                    src="@/assets/img/icons/quatation-mark.svg"
                    class="img-fluid"
                    alt="Img"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="view-all text-center">
            <router-link to="/pages/testimonial" class="btn btn-secondary"
              >View all Testimonails</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
